import React, { useContext, memo } from "react";
import { CohortTable } from "@metacrm/metacrm-material-ui/dist/Table";
import { Box } from "@mui/material";
import CommunityAnalysisContext from "features/metadesk/CommunityAnalysis/contexts/CommunityAnalysis.context";
import { isEmpty } from "lodash-es";
import _ from "lodash";
import EmptyIconStatus from "components/EmptyState/EmptyIconStatus";
const hasSingleKey = (obj) => {
  if (!obj) {
    return true;
  }
  if (Object.keys(obj).length === 1 || isEmpty(obj)) {
    return true;
  }
  return false;
};

const HeatMap = ({ chartData, heatColor = "#bd376f", context }) => {
  const { timeFrame } = useContext(context);

  const isEmptyData = hasSingleKey(chartData[timeFrame]);

  if (isEmptyData) {
    return <EmptyIconStatus icon="chart" />;
  }

  return (
    <Box
      sx={{
        width: "100%",
        overflow: "auto",
        margin: "0 auto",
        flex: 1,
      }}
    >
      {!isEmpty(chartData) && (
        <CohortTable
          data={chartData[timeFrame]}
          color={heatColor}
          tableHeight={"100%"}
          unit={_.upperFirst(timeFrame).replace("s", "")}
        />
      )}
    </Box>
  );
};

export default memo(HeatMap);
